// extracted by mini-css-extract-plugin
export var alt = "ImageCarousel-module--alt--ad194";
export var container = "ImageCarousel-module--container--c5019";
export var desktopOnly = "ImageCarousel-module--desktopOnly--4a56c";
export var main = "ImageCarousel-module--main--07057";
export var mobileOnly = "ImageCarousel-module--mobileOnly--b803c";
export var textLeft = "ImageCarousel-module--textLeft--ca892";
export var visuallyHidden = "ImageCarousel-module--visuallyHidden--83aa6";